<template>
  <Card class="tw-h-full tw-max-h-[290px]">
    <CardContent class="tw-pt-4">
      <CardTitle class="tw-uppercase tw-text-[0.8rem]">
        {{ t('profile.titles.notification_preferences') }}
      </CardTitle>

      <div>
        <Select
          v-if="currentUser?.email_notification_preference"
          v-model="currentUser.email_notification_preference"
        >
          <SelectTrigger>
            <SelectValue placeholder="" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="daily">
              {{ t('profile.notification_preferences.daily') }}
            </SelectItem>
            <SelectItem value="never">
              {{ t('profile.notification_preferences.never') }}
            </SelectItem>
            <SelectItem value="immediate">
              {{ t('profile.notification_preferences.immediate') }}
            </SelectItem>
          </SelectContent>
        </Select>
      </div>
      <Button class="tw-w-full tw-mt-4" @click="updateNotificationPref()">
        {{ t('profile.titles.update_preferences') }}
      </Button>
    </CardContent>
  </Card>
</template>

<script setup lang="ts">
import { useUserStore } from '@/stores/user.store';
import { storeToRefs } from 'pinia';
import { useToast } from 'vue-toast-notification';
import { useI18n } from 'vue-i18n';
import { Card, CardContent, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';

const toast = useToast();
const { t } = useI18n();

const { currentUser } = storeToRefs(useUserStore());
const { editUserProfile } = useUserStore();

const updateNotificationPref = async () => {
  if (!currentUser?.value) return;
  try {
    await editUserProfile({
      email_notification_preference: currentUser.value.email_notification_preference,
    });
    toast.open({
      message: t('profile.titles.notification_preferences_update_success'),
      type: 'success',
    });
  } catch (error) {
    toast.open({
      message: t('profile.titles.notification_preferences_update_failed'),
      type: 'error',
    });
  }
};
</script>

<style scoped>
/* Using Tailwind classes - no additional styles needed */
</style>
